export const MODEL_TEMPERATURE_LABEL = 'Temperature';

export const MODEL_LABEL = 'LLM Model';
export const MODEL_HELPER_TEXT = 'The LLM model to be used for the voice call.';
